<template>
    <div class="modal fade slide-in-top" id="video-popup"   aria-labelledby="video-popup"  data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1"  aria-hidden="true" v-show="showVideo">
        <div class="modal-dialog modal-dialog-centered m-auto modal-sm-down">
            <div class="modal-content p-0 rounded-0 border-0" style="background: transparent;">

                <div class="modal-body">

                    <button type="button" data-bs-dismiss="modal" aria-label="Close" @click="closeAndsetIframeFalse">
                        <svg style="position: absolute;right: 40px;top: 16px;" width="1em" height="1.5em"  viewBox="-0.5 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M3 21.32L21 3.32001" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M3 3.32001L21 21.32" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </button>
                    <div v-if="isLoading" class="loading-container">
                        <span class="spinner"></span>
                    </div>
                    <iframe
                        v-if="showVideo"
                        class="embed-responsive-item"
                        :src="computedVideoUrl"
                        width="100%"
                        :height="height"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen

                    ></iframe>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            autoplayAndMuted: '', // Reset autoplay and mute parameters
            height: '',
            showVideo: false,
            isLoading: false,
            data: {}
        }
    },
    methods:{
        closeAndsetIframeFalse(){
            this.showVideo = false
            this.dispaly = 'none'
        },
        async openModalAndSetOptions(data) {
            // Show loading spinner and video immediately
            this.isLoading = true;
            this.showVideo = true;

            const params = { id: data.id };

            try {

                // Make the Axios GET request with parameters
                const response = await axios.get(route('link.display.video'), { params });
                //console.log('Success:', response.data);

                // Assign the response data to this.data
                this.data = response.data.data;

                // Update autoplay and mute parameters
                //this.autoplayAndMuted = this.getAutoplayAndMutedParams();

            } catch (error) {
                // Handle errors
                console.error('There were errors:', error.response ? error.response.data : error);
            } finally {
                // Hide loading spinner once the request completes
                this.isLoading = false;
            }
        },
        isYouTubeHost() {
            const youtubeRegex = /youtube/;  // This will match any host containing "youtube"
            return youtubeRegex.test(this.data.platform);
        },
        videoUrl() {
            // Reset autoplay and mute parameters for each call
            this.autoplayAndMuted = this.getAutoplayAndMutedParams();

            if (this.data.platform === 'vimeo' && this.data.video_id) {
                this.height = '216';
                return `https://player.vimeo.com/video/` + this.data.video_id;
            } else if (this.isYouTubeHost() && this.data.video_id) {
                this.height = '216';
                return `https://www.youtube.com/embed/` + this.data.video_id;
            } else if (this.data.platform === 'facebook') {
                this.height = '500';
                const pattern = 'https://www.facebook.com/watch/?v=';
                if (this.data.url.includes(pattern)) {
                    return 'https://www.facebook.com/plugins/video.php?href=https://www.facebook.com/watch/?v=' + this.data.video_id;
                } else {
                    return `https://www.facebook.com/plugins/video.php?href=` + this.data.url;
                }
            }

            return ''; // Fallback
        },
        getAutoplayAndMutedParams() {
            let params = '';
            if (this.data && this.data.display_options_video_autoplay) {
                params = this.data.platform === 'facebook' ? '&autoplay=1' : '?autoplay=1';
            }
            if (this.data && this.data.display_options_video_mutevideo) {
                params += '&mute=1';
            }
            return params;
        }

    },

    computed: {
        computedVideoUrl() {
            // Use videoUrl() to get the URL with autoplay and mute parameters
            //return this.videoUrl() + this.autoplayAndMuted;
            return this.videoUrl();

        }
    },
    expose:['openModalAndSetOptions']

}
</script>
<style scoped>
.loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    height: 100px;
}

/* Spinner */
.spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-top: 4px solid var(--primary); /* Same green color */
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
